<template>
  <v-dialog v-model="internalValue" width="95vw" max-width="1200" persistent>
    <v-card>
      <!-- Header -->
      <v-card-title class="d-flex align-center pa-4">
        <span class="body-1 font-weight-bold">
          {{ metaEmEdicao ? "Editar Meta" : "Nova Meta" }} ·
          {{ subEtapaTitulo }}
        </span>
        <v-spacer></v-spacer>
        <span class="caption grey--text mr-3">{{ subEtapa }} / 4</span>
        <v-btn icon small @click="fecharDialogNovaMeta">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Barra de progresso das etapas -->
      <div class="d-flex px-4 pb-2" style="gap: 4px">
        <div
          v-for="n in 4"
          :key="n"
          :style="{
            flex: 1,
            height: '4px',
            borderRadius: '2px',
            background: n <= subEtapa ? '#1976d2' : 'rgba(0,0,0,0.12)',
            transition: 'background 0.3s'
          }"
        ></div>
      </div>

      <v-divider></v-divider>

      <!-- Corpo do modal -->
      <v-card-text style="padding: 0">
        <div style="display: flex; align-items: stretch; height: 63vh">

          <!-- Coluna principal (75%) -->
          <div style="flex: 0 0 75%; width: 75%; padding: 16px; border-right: 1px solid rgba(0,0,0,0.1); overflow-y: auto">
            <ModalCadastroSubEtapaParticipantes
              v-if="subEtapa === 1"
              v-model="novaMetaForm.colaboradoresSelecionados"
              :colaboradores="colaboradoresParticipantes"
              :loading="loadingColaboradores"
            />
            <ModalCadastroSubEtapaRealizado
              v-else-if="subEtapa === 2"
              :form="novaMetaForm"
              :equipes="equipesLocais"
              :empresas="getEmpresasParticipantes"
              :loadingEquipes="loadingEquipes"
              :loadingEmpresas="loadingEmpresas"
            />
            <ModalCadastroSubEtapaObjetivo
              v-else-if="subEtapa === 3"
              :form="novaMetaForm"
              :campanha="campanha"
              :editando="editandoMeta"
            />
            <ModalCadastroSubEtapaCalculo
              v-else-if="subEtapa === 4"
              :form="novaMetaForm"
              :campanha="campanha"
              :arrayFechamentosSemanal="arrayFechamentosSemanal"
              :custo-estimado="custoEstimado"
            />
          </div>

          <!-- Resumo lateral (25%) -->
          <div style="flex: 0 0 25%; width: 25%; display: flex; flex-direction: column; overflow: hidden">
            <ModalCadastroSubEtapaResumoMeta
              :form="novaMetaForm"
              :subEtapa="subEtapa"
              :custoEstimado="custoEstimado"
              :empresas="getEmpresasParticipantes"
            />
          </div>

        </div>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Ações -->
      <v-card-actions class="d-flex justify-space-between pa-4">
        <v-btn outlined @click="subEtapaAnterior">
          <v-icon left small>mdi-arrow-left</v-icon>
          {{ subEtapa > 1 ? "Anterior" : "Cancelar" }}
        </v-btn>
        <div class="d-flex align-center" style="gap: 8px">
          <v-btn
            v-if="subEtapa < 4"
            color="primary"
            @click="subEtapaProxima"
            :disabled="!subEtapaValida"
          >
            Próximo<v-icon right small>mdi-arrow-right</v-icon>
          </v-btn>
          <v-btn
            v-else
            color="primary"
            @click="salvarNovaMeta"
            :loading="loadingSalvar"
            :disabled="!subEtapaValida"
          >
            <v-icon left small>mdi-check</v-icon>Salvar
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import colaboradorService from "@/services/colaborador";
import campanhas from "@/services/http/campanhaService";
import { mapGetters } from "vuex";
import http, { getApiError } from "@/services/http";

import ModalCadastroSubEtapaParticipantes from "./ModalCadastroSubEtapaParticipantes";
import ModalCadastroSubEtapaRealizado from "./ModalCadastroSubEtapaRealizado";
import ModalCadastroSubEtapaObjetivo from "./ModalCadastroSubEtapaObjetivo";
import ModalCadastroSubEtapaCalculo from "./ModalCadastroSubEtapaCalculo";
import ModalCadastroSubEtapaResumoMeta from "./ModalCadastroSubEtapaResumoMeta";
import { calcCustoEstimadoChassi, calcPorColaboradorItens, calcPorColaboradorIndicadores, calcCustoParticipante } from "./calculo/custoEstimadoUtils";
import { montarExtrasMeta } from "./payloadMetaExtras";
import { metaColaboradorValida } from "./metaColaboradorValidacaoUtils";
import { montarMetasCalculadas } from "./metaColaboradorLeituraUtils";
import {
  detectarMetaIndividual,
  montarMetasIndividuaisItens,
  montarMetasIndividuaisIndicador
} from "./metaIndividualLeituraUtils";
import { ordenarFaixas } from "./faixasLeituraUtils";

export default {
  name: "ModalCadastroMeta",

  components: {
    ModalCadastroSubEtapaParticipantes,
    ModalCadastroSubEtapaRealizado,
    ModalCadastroSubEtapaObjetivo,
    ModalCadastroSubEtapaCalculo,
    ModalCadastroSubEtapaResumoMeta
  },

  props: {
    value: { type: Boolean, default: false },
    metaEmEdicao: { type: Object, default: null },
    campanha: { type: Object, default: () => ({}) },
    metasRegistradas: { type: Array, default: () => [] },
    arrayFechamentosSemanal: { type: Array, default: () => [] },
    // Mapa { id_campanha_meta: [{ ano_ref, mes_ref }] } vindo junto da
    // resposta de metasRegistradas, fora das linhas (uma vez por meta, nao
    // por linha) — ver SectionPublicoMeta.carregarMetasCadastradas.
    periodosMedia: { type: Object, default: () => ({}) },
    // Mapa { id_campanha_meta: [{ faixa_de, faixa_ate, percentual_crescimento }] },
    // mesmo padrao de periodosMedia — so tem conteudo quando o crescimento da
    // media e Progressivo por faixa. Ver editarMeta.
    faixasMedia: { type: Object, default: () => ({}) },
    // Mapa { id_campanha_meta: [{ id_colaborador, id_empresa, valor_meta,
    // valor_media_referencia, meta_manual, valor_bonus }] }, mesmo padrao de
    // periodosMedia (irmao de data na resposta, chave ausente quando a meta
    // nao tem participante) — ver metaColaboradorLeituraUtils.montarMetasCalculadas.
    metasColaborador: { type: Object, default: () => ({}) }
  },

  data() {
    return {
      subEtapa: 1,
      editandoMeta: false,
      equipesLocais: [],
      colaboradoresEquipesRaw: [],
      loadingEquipes: false,
      loadingEmpresas: false,
      colaboradoresParticipantes: [],
      loadingColaboradores: false,
      loadingSalvar: false,
      novaMetaForm: {
        colaboradoresSelecionados: [],
        tipoRealizado: null,
        empresasRealizadoSelecionadas: [],
        equipesSelecionadas: [],
        tipoConteudo: null,
        origemConteudo: 1,
        usaMetaColaborador: false,
        origemMeta: 1,
        origemBonusColaborador: 1,
        mesesReferencia: [],
        percentualCrescimento: 15,
        valorMinimoMeta: 10,
        // 1 Fixo, 2 Progressivo por faixa — default Fixo preserva o
        // comportamento de toda meta que nao mexe neste campo.
        tipoCrescimentoMedia: 1,
        faixasCrescimento: [],
        metasCalculadas: {},
        valorBonusColaborador: null,
        comissaoReferencia: "P2",
        comissaoPercentual: 50,
        // Comissao P2 por colaborador na competencia, preenchida por
        // TabelaMetasCalculadas quando a origem do bonus e "% sobre
        // referencia". Alimenta o custo estimado e o valor_bonus gravado por
        // participante (montarExtrasMeta).
        //
        // Comeca null, nao {}: null significa "ainda nao busquei" e {}
        // significa "busquei e ninguem tem comissao". A diferenca decide se o
        // payload grava 0 (calculado, e deu zero) ou null (desconhecido, a
        // apuracao preenche) — ver montarExtrasMeta.
        comissaoParticipantes: null,
        indicadoresSelecionados: [],
        chassisSelecionados: [],
        modelosSelecionados: [],
        tipoCalculo: 1,
        tipoPagamento: 1,
        valorBonus: null,
        metasIndicadores: {},
        metasModelos: {},
        tipoMeta: "coletiva",
        metasIndividuais: {},
        metasIndividuaisItens: {}
      }
    };
  },

  computed: {
    ...mapGetters({
      getEmpresasParticipantes: "campanha/getEmpresasParticipantes"
    }),

    internalValue: {
      get() { return this.value; },
      set(val) { this.$emit("input", val); }
    },

    subEtapaTitulo() {
      const titulos = { 1: "Participantes", 2: "Realizado", 3: "Objetivo", 4: "Cálculo" };
      return titulos[this.subEtapa] || "";
    },

    metaInfoMap() {
      const map = {};
      for (const row of this.metasRegistradas) {
        const id = row.id_campanha_meta;
        if (!id) continue;
        if (!map[id]) {
          map[id] = {
            colaboradores: [],
            empresas: [],
            equipes: [],
            indicadores: [],
            faixasIndicador: [],
            chassi: [],
            modelos: [],
            faixasModelo: [],
            pecas: [],
            faixasPeca: [],
            servicos: [],
            faixasServico: []
          };
        }
        const m = map[id];
        if (row.colaborador) {
          // A identidade de um participante e (colaborador, EMPRESA), nao o
          // nome: quem atua em mais de uma empresa da campanha e um vinculo por
          // empresa, e a meta grava um por vinculo. Deduplicar so pelo nome
          // guardava a primeira empresa e descartava as outras — e editarMeta,
          // abaixo, reselecionava todas as empresas da pessoa, multiplicando a
          // meta a cada edicao.
          const key = `${row.colaborador}|${row.id_empresa}`;
          if (!m.colaboradores.some(c => `${c.nome}|${c.id_empresa}` === key)) {
            m.colaboradores.push({
              id_colaborador: row.id_colaborador || null,
              nome: row.colaborador,
              funcao: row.funcao,
              id_empresa: row.id_empresa,
              nome_empresa: row.nome_empresa,
              nome_equipe: row.nome_equipe || null
            });
          }
        }
        if (row.id_equipe) {
          if (!m.equipes.some(e => e.id_equipe == row.id_equipe)) {
            m.equipes.push({ id_equipe: row.id_equipe, nome_equipe: row.nome_equipe || null });
          }
        }
        if (row.id_empresa && row.nome_empresa) {
          if (!m.empresas.some(e => e.id_empresa == row.id_empresa)) {
            m.empresas.push({ id_empresa: row.id_empresa, nome_empresa: row.nome_empresa });
          }
        }
        if (row.id_tipo_conteudo == 1 && row.id_tipo_calculo != 2 && row.id_indicador) {
          if (!m.indicadores.some(i => i.id_indicador == row.id_indicador)) {
            m.indicadores.push({ id_indicador: row.id_indicador, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus });
          }
        }
        if (row.id_tipo_conteudo == 1 && row.id_tipo_calculo == 2 && row.id_indicador && row.qtde_de != null) {
          const key = `${row.id_indicador}-${row.qtde_de}-${row.qtde_ate}`;
          if (!m.faixasIndicador.some(f => f._key === key)) {
            m.faixasIndicador.push({ _key: key, id_indicador: row.id_indicador, qtde_de: row.qtde_de, qtde_ate: row.qtde_ate, valor_bonus: row.valor_bonus });
          }
        }
        if (row.id_tipo_conteudo == 2 && row.chassi_completo) {
          if (!m.chassi.some(c => c.chassi_completo === row.chassi_completo)) {
            m.chassi.push({ chassi_completo: row.chassi_completo, chassi_resumido: row.chassi_resumido, valor_bonus: row.valor_bonus });
          }
        }
        if (row.id_tipo_conteudo == 3 && row.id_tipo_calculo != 2 && row.id_produto) {
          if (!m.modelos.some(p => p.id_produto == row.id_produto)) {
            m.modelos.push({ id_produto: row.id_produto, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus, descricao_modelo: row.produto || null });
          }
        }
        if (row.id_tipo_conteudo == 3 && row.id_tipo_calculo == 2 && row.id_produto && row.qtde_de != null) {
          const key = `${row.id_produto}-${row.qtde_de}-${row.qtde_ate}`;
          if (!m.faixasModelo.some(f => f._key === key)) {
            m.faixasModelo.push({ _key: key, id_produto: row.id_produto, qtde_de: row.qtde_de, qtde_ate: row.qtde_ate, valor_bonus: row.valor_bonus, descricao_modelo: row.produto || null });
          }
        }
        if (row.id_tipo_conteudo == 4 && row.id_tipo_calculo != 2 && row.id_peca) {
          if (!m.pecas.some(p => p.id_peca == row.id_peca)) {
            m.pecas.push({ id_peca: row.id_peca, peca_acessorio: row.peca_acessorio || null, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus });
          }
        }
        if (row.id_tipo_conteudo == 4 && row.id_tipo_calculo == 2 && row.id_peca && row.qtde_de != null) {
          const key = `${row.id_peca}-${row.qtde_de}-${row.qtde_ate}`;
          if (!m.faixasPeca.some(f => f._key === key)) {
            m.faixasPeca.push({ _key: key, id_peca: row.id_peca, peca_acessorio: row.peca_acessorio || null, qtde_de: row.qtde_de, qtde_ate: row.qtde_ate, valor_bonus: row.valor_bonus });
          }
        }
        if (row.id_tipo_conteudo == 5 && row.id_tipo_calculo != 2 && row.id_servico) {
          if (!m.servicos.some(p => p.id_servico == row.id_servico)) {
            m.servicos.push({ id_servico: row.id_servico, servico: row.servico || null, valor_meta: row.valor_meta, valor_bonus: row.valor_bonus });
          }
        }
        if (row.id_tipo_conteudo == 5 && row.id_tipo_calculo == 2 && row.id_servico && row.qtde_de != null) {
          const key = `${row.id_servico}-${row.qtde_de}-${row.qtde_ate}`;
          if (!m.faixasServico.some(f => f._key === key)) {
            m.faixasServico.push({ _key: key, id_servico: row.id_servico, servico: row.servico || null, qtde_de: row.qtde_de, qtde_ate: row.qtde_ate, valor_bonus: row.valor_bonus });
          }
        }
      }
      return map;
    },

    subEtapaValida() {
      const form = this.novaMetaForm;
      if (this.subEtapa === 1) return form.colaboradoresSelecionados.length > 0;
      if (this.subEtapa === 2) {
        if (!form.tipoRealizado) return false;
        if (form.tipoRealizado === 2) return form.equipesSelecionadas.length > 0;
        if (form.tipoRealizado === 3) return form.empresasRealizadoSelecionadas.length > 0;
        return true;
      }
      if (this.subEtapa === 3) {
        if (!form.tipoConteudo) return false;
        if (form.tipoConteudo === 1) return form.indicadoresSelecionados.length > 0;
        if (form.tipoConteudo === 2) return form.chassisSelecionados.length > 0;
        if (form.tipoConteudo === 3) return form.modelosSelecionados.length > 0;
        if (form.tipoConteudo === 4) return form.modelosSelecionados.length > 0;
        if (form.tipoConteudo === 5) return form.modelosSelecionados.length > 0;
        return true;
      }
      if (this.subEtapa === 4) {
        // Camada do participante e exclusiva do objetivo Modelo (tipoConteudo
        // 3), mesma guarda usada no payload (montarExtrasMeta), no custo
        // estimado (calcCustoParticipante) e na UI (SubEtapaCalculoModelo so
        // e renderizado quando tipoConteudo === 3). Hoje inalcancavel (o UI
        // nunca liga usaMetaColaborador fora do objetivo Modelo), mas sem a
        // guarda esta seria a unica das quatro consumidoras sem ela.
        const metaColaboradorOk = form.tipoConteudo === 3 ? metaColaboradorValida(form) : true;
        return this.objetivoCalculoValido(form) && metaColaboradorOk;
      }
      return true;
    },

    custoEstimado() {
      const form = this.novaMetaForm;
      const n = form.colaboradoresSelecionados.length || 1;
      const nSemanas =
        this.campanha.id_tipo_dado === "C" && this.arrayFechamentosSemanal.length > 0
          ? this.arrayFechamentosSemanal.length
          : 1;

      if (form.tipoConteudo === 2) {
        return calcCustoEstimadoChassi(form.chassisSelecionados);
      }

      const keyMap = { 3: m => m.id_produto, 4: m => m.id_peca, 5: m => m.id_servico };
      if (keyMap[form.tipoConteudo]) {
        const porColaboradorObjetivo = calcPorColaboradorItens(
          form.modelosSelecionados, form.metasModelos, keyMap[form.tipoConteudo],
          form.tipoCalculo, form.tipoPagamento
        );
        // Camada do participante e exclusiva do objetivo Modelo (tipoConteudo
        // 3); usa a mesma calcCustoParticipante de SubEtapaCalculoModelo, pro
        // resumo lateral nunca voltar a divergir do card da etapa.
        const participante = form.tipoConteudo === 3
          ? calcCustoParticipante(form)
          : { porColaborador: 0, total: 0, sobreReferencia: false };
        const porColaborador = porColaboradorObjetivo + participante.porColaborador;
        return { porColaborador, total: porColaborador * n, nSemanas: 1, sobreReferencia: participante.sobreReferencia };
      }

      // Indicador (tipoConteudo === 1)
      const porColaborador = calcPorColaboradorIndicadores(
        form.indicadoresSelecionados, form.metasIndicadores,
        form.tipoCalculo, form.tipoPagamento, form.valorBonus
      );
      return { porColaborador, total: porColaborador * n * nSemanas, nSemanas };
    }
  },

  watch: {
    value(val) {
      if (val) {
        if (this.metaEmEdicao) {
          this.editarMeta(this.metaEmEdicao);
        } else {
          this.iniciarNovaMeta();
        }
      }
    }
  },

  methods: {
    // Logica pre-existente da sub-etapa 4 (Calculo) referente ao OBJETIVO da
    // meta (indicador/chassi/modelo/peca/servico) — nao muda com a Task 4.
    // A meta do colaborador (opcional) e validada a parte, em
    // metaColaboradorValida, e as duas precisam passar para liberar o Salvar.
    objetivoCalculoValido(form) {
      const itens = form.metasIndividuaisItens || {};
      if (form.tipoConteudo === 2) {
        if (form.tipoMeta === "individual") {
          return form.colaboradoresSelecionados.length > 0 &&
            form.chassisSelecionados.length > 0 &&
            form.colaboradoresSelecionados.every(c =>
              form.chassisSelecionados.every(ch =>
                parseFloat((itens[c.id_colaborador] || {})[ch.chassi_completo]?.valorBonus) > 0
              )
            );
        }
        return (
          form.chassisSelecionados.length > 0 &&
          form.chassisSelecionados.every(c => parseFloat(c.valor_bonus) > 0)
        );
      }
      if (form.tipoConteudo === 3) {
        if (form.modelosSelecionados.length === 0 || !form.tipoCalculo) return false;
        if (form.tipoMeta === "individual") {
          if (form.tipoCalculo === 2) {
            return form.colaboradoresSelecionados.every(c =>
              form.modelosSelecionados.every(m => {
                const faixas = (itens[c.id_colaborador] || {})[m.id_produto]?.faixas || [];
                return faixas.length >= 2 &&
                  faixas.every(f => f.minimo !== "" && f.maximo !== "" && f.bonus &&
                    parseFloat(f.maximo) >= parseFloat(f.minimo));
              })
            );
          }
          return form.colaboradoresSelecionados.every(c =>
            form.modelosSelecionados.every(m => {
              const item = (itens[c.id_colaborador] || {})[m.id_produto] || {};
              return parseFloat(item.metaValor) > 0 && parseFloat(item.valorBonus) > 0;
            })
          );
        }
        if (form.tipoCalculo === 2) {
          return form.modelosSelecionados.every(m => {
            const faixas = this.getFaixasModelo(m.id_produto);
            return faixas.length >= 2 &&
              faixas.every(f => f.minimo !== "" && f.maximo && f.bonus) &&
              faixas.every((f, idx) => !this.getFaixaOrdemErroModelo(m.id_produto, idx));
          });
        }
        return form.modelosSelecionados.every(m => {
          return parseFloat(this.getMetaModeloValor(m.id_produto, "metaValor")) > 0 &&
            parseFloat(this.getMetaModeloValor(m.id_produto, "valorBonus")) > 0;
        });
      }
      if (form.tipoConteudo === 4) {
        if (form.modelosSelecionados.length === 0 || !form.tipoCalculo) return false;
        if (form.tipoMeta === "individual") {
          if (form.tipoCalculo === 2) {
            return form.colaboradoresSelecionados.every(c =>
              form.modelosSelecionados.every(m => {
                const faixas = (itens[c.id_colaborador] || {})[m.id_peca]?.faixas || [];
                return faixas.length >= 2 &&
                  faixas.every(f => f.minimo !== "" && f.maximo !== "" && f.bonus &&
                    parseFloat(f.maximo) >= parseFloat(f.minimo));
              })
            );
          }
          return form.colaboradoresSelecionados.every(c =>
            form.modelosSelecionados.every(m => {
              const item = (itens[c.id_colaborador] || {})[m.id_peca] || {};
              return parseFloat(item.metaValor) > 0 && parseFloat(item.valorBonus) > 0;
            })
          );
        }
        if (form.tipoCalculo === 2) {
          return form.modelosSelecionados.every(m => {
            const faixas = this.getFaixasModelo(m.id_peca);
            return faixas.length >= 2 &&
              faixas.every(f => f.minimo !== "" && f.maximo && f.bonus) &&
              faixas.every((f, idx) => !this.getFaixaOrdemErroModelo(m.id_peca, idx));
          });
        }
        return form.modelosSelecionados.every(m => {
          return parseFloat(this.getMetaModeloValor(m.id_peca, "metaValor")) > 0 &&
            parseFloat(this.getMetaModeloValor(m.id_peca, "valorBonus")) > 0;
        });
      }
      if (form.tipoConteudo === 5) {
        if (form.modelosSelecionados.length === 0 || !form.tipoCalculo) return false;
        if (form.tipoMeta === "individual") {
          if (form.tipoCalculo === 2) {
            return form.colaboradoresSelecionados.every(c =>
              form.modelosSelecionados.every(m => {
                const faixas = (itens[c.id_colaborador] || {})[m.id_servico]?.faixas || [];
                return faixas.length >= 2 &&
                  faixas.every(f => f.minimo !== "" && f.maximo !== "" && f.bonus &&
                    parseFloat(f.maximo) >= parseFloat(f.minimo));
              })
            );
          }
          return form.colaboradoresSelecionados.every(c =>
            form.modelosSelecionados.every(m => {
              const item = (itens[c.id_colaborador] || {})[m.id_servico] || {};
              return parseFloat(item.metaValor) > 0 && parseFloat(item.valorBonus) > 0;
            })
          );
        }
        if (form.tipoCalculo === 2) {
          return form.modelosSelecionados.every(m => {
            const faixas = this.getFaixasModelo(m.id_servico);
            return faixas.length >= 2 &&
              faixas.every(f => f.minimo !== "" && f.maximo && f.bonus) &&
              faixas.every((f, idx) => !this.getFaixaOrdemErroModelo(m.id_servico, idx));
          });
        }
        return form.modelosSelecionados.every(m => {
          return parseFloat(this.getMetaModeloValor(m.id_servico, "metaValor")) > 0 &&
            parseFloat(this.getMetaModeloValor(m.id_servico, "valorBonus")) > 0;
        });
      }
      if (!form.tipoCalculo) return false;
      if (form.tipoMeta === "individual") {
        if (form.indicadoresSelecionados.length === 0) return false;
        if (form.tipoCalculo !== 2) {
          return form.colaboradoresSelecionados.every(c => {
            const ind = form.metasIndividuais[c.id_colaborador];
            return parseFloat(ind?.valorBonus) > 0 &&
              form.indicadoresSelecionados.every(indicador =>
                parseFloat(ind && ind.metas && ind.metas[indicador.id_indicador]) > 0
              );
          });
        }
        return form.colaboradoresSelecionados.every(c => {
          return form.indicadoresSelecionados.every(ind => {
            const faixas = form.metasIndividuais[c.id_colaborador]?.metas?.[ind.id_indicador]?.faixas || [];
            return faixas.length >= 2 &&
              faixas.every(f => f.minimo !== "" && f.maximo !== "" && f.bonus &&
                parseFloat(f.maximo) >= parseFloat(f.minimo));
          });
        });
      }
      if (form.tipoCalculo !== 2) {
        if (!form.valorBonus) return false;
        if (form.indicadoresSelecionados.length === 0) return false;
        return form.indicadoresSelecionados.every(ind =>
          parseFloat(form.metasIndicadores[ind.id_indicador]?.metaValor) > 0
        );
      }
      if (form.tipoConteudo === 1 && form.indicadoresSelecionados.length > 0) {
        return form.indicadoresSelecionados.every(ind => {
          const faixas = this.getFaixasIndicador(ind.id_indicador);
          return faixas.length >= 2 &&
            faixas.every(f => f.minimo !== "" && f.maximo && f.bonus) &&
            faixas.every((f, idx) => !this.getFaixaOrdemErro(ind.id_indicador, idx));
        });
      }
      return true;
    },

    fecharDialogNovaMeta() {
      this.$emit("input", false);
      this.subEtapa = 1;
      this.editandoMeta = false;
    },

    subEtapaProxima() {
      if (this.subEtapa < 4) {
        this.subEtapa++;
        if (this.subEtapa === 2 && this.equipesLocais.length === 0) {
          this.carregarEquipes();
        }
      }
    },

    subEtapaAnterior() {
      if (this.subEtapa > 1) this.subEtapa--;
      else this.fecharDialogNovaMeta();
    },

    metaInfo(id) {
      return this.metaInfoMap[id] || {
        colaboradores: [],
        empresas: [],
        equipes: [],
        indicadores: [],
        faixasIndicador: [],
        chassi: [],
        modelos: [],
        faixasModelo: [],
        pecas: [],
        faixasPeca: [],
        servicos: [],
        faixasServico: []
      };
    },

    async iniciarNovaMeta() {
      this.subEtapa = 1;
      this.editandoMeta = false;
      this.equipesLocais = [];
      this.colaboradoresEquipesRaw = [];
      this.novaMetaForm = {
        colaboradoresSelecionados: [],
        tipoRealizado: null,
        empresasRealizadoSelecionadas: [],
        equipesSelecionadas: [],
        tipoConteudo: 1,
        origemConteudo: 1,
        usaMetaColaborador: false,
        origemMeta: 1,
        origemBonusColaborador: 1,
        mesesReferencia: [],
        percentualCrescimento: 15,
        valorMinimoMeta: 10,
        // 1 Fixo, 2 Progressivo por faixa — default Fixo preserva o
        // comportamento de toda meta que nao mexe neste campo.
        tipoCrescimentoMedia: 1,
        faixasCrescimento: [],
        metasCalculadas: {},
        valorBonusColaborador: null,
        comissaoReferencia: "P2",
        comissaoPercentual: 50,
        // Comissao P2 por colaborador na competencia, preenchida por
        // TabelaMetasCalculadas quando a origem do bonus e "% sobre
        // referencia". Alimenta o custo estimado e o valor_bonus gravado por
        // participante (montarExtrasMeta).
        //
        // Comeca null, nao {}: null significa "ainda nao busquei" e {}
        // significa "busquei e ninguem tem comissao". A diferenca decide se o
        // payload grava 0 (calculado, e deu zero) ou null (desconhecido, a
        // apuracao preenche) — ver montarExtrasMeta.
        comissaoParticipantes: null,
        indicadoresSelecionados: [],
        chassisSelecionados: [],
        modelosSelecionados: [],
        tipoCalculo: 1,
        tipoPagamento: 1,
        valorBonus: null,
        metasIndicadores: {},
        metasModelos: {},
        tipoMeta: "coletiva",
        metasIndividuais: {},
        metasIndividuaisItens: {}
      };
      await this.carregarColaboradoresParticipantes();
    },

    async editarMeta(meta) {
      const info = this.metaInfo(meta.id_campanha_meta);

      await this.carregarColaboradoresParticipantes();

      // Casa por (colaborador, empresa). So por id_colaborador reselecionaria a
      // pessoa em TODAS as empresas da campanha, e o proximo Salvar gravaria uma
      // linha por empresa — a meta cresceria sozinha a cada edicao.
      const colaboradoresSelecionados = this.colaboradoresParticipantes.filter(c =>
        info.colaboradores.some(ic => {
          const mesmaEmpresa = ic.id_empresa == null || ic.id_empresa == c.id_empresa;
          return ic.id_colaborador
            ? ic.id_colaborador == c.id_colaborador && mesmaEmpresa
            : ic.nome === c.nome && mesmaEmpresa;
        })
      );

      const metasIndicadores = {};
      if (meta.id_tipo_conteudo == 1) {
        if (meta.id_tipo_calculo != 2) {
          info.indicadores.forEach(ind => {
            metasIndicadores[ind.id_indicador] = {
              metaValor: ind.valor_meta != null ? String(ind.valor_meta) : "",
              valorBonus: ind.valor_bonus != null ? String(ind.valor_bonus) : ""
            };
          });
        } else {
          const seen = new Set(info.faixasIndicador.map(f => f.id_indicador));
          seen.forEach(id => {
            metasIndicadores[id] = {
              // ordenarFaixas: a API devolve as linhas na ordem do banco, e a
              // posicao no array e o que a validacao de ordem do form usa.
              faixas: ordenarFaixas(info.faixasIndicador
                .filter(f => f.id_indicador === id)
                .map(f => ({ minimo: f.qtde_de, maximo: f.qtde_ate, bonus: f.valor_bonus })))
            };
          });
        }
      }

      const metasModelos = {};
      if (meta.id_tipo_conteudo == 3) {
        if (meta.id_tipo_calculo != 2) {
          info.modelos.forEach(m => {
            metasModelos[m.id_produto] = {
              metaValor: m.valor_meta != null ? String(m.valor_meta) : "",
              valorBonus: m.valor_bonus != null ? String(m.valor_bonus) : ""
            };
          });
        } else {
          const seen = new Set(info.faixasModelo.map(f => f.id_produto));
          seen.forEach(id => {
            metasModelos[id] = {
              faixas: ordenarFaixas(info.faixasModelo
                .filter(f => f.id_produto === id)
                .map(f => ({ minimo: f.qtde_de, maximo: f.qtde_ate, bonus: f.valor_bonus })))
            };
          });
        }
      }
      if (meta.id_tipo_conteudo == 4) {
        if (meta.id_tipo_calculo != 2) {
          info.pecas.forEach(p => {
            metasModelos[p.id_peca] = {
              metaValor: p.valor_meta != null ? String(p.valor_meta) : "",
              valorBonus: p.valor_bonus != null ? String(p.valor_bonus) : ""
            };
          });
        } else {
          const seen = new Set(info.faixasPeca.map(f => f.id_peca));
          seen.forEach(id => {
            metasModelos[id] = {
              faixas: ordenarFaixas(info.faixasPeca
                .filter(f => f.id_peca === id)
                .map(f => ({ minimo: f.qtde_de, maximo: f.qtde_ate, bonus: f.valor_bonus })))
            };
          });
        }
      }
      if (meta.id_tipo_conteudo == 5) {
        if (meta.id_tipo_calculo != 2) {
          info.servicos.forEach(s => {
            metasModelos[s.id_servico] = {
              metaValor: s.valor_meta != null ? String(s.valor_meta) : "",
              valorBonus: s.valor_bonus != null ? String(s.valor_bonus) : ""
            };
          });
        } else {
          const seen = new Set(info.faixasServico.map(f => f.id_servico));
          seen.forEach(id => {
            metasModelos[id] = {
              faixas: ordenarFaixas(info.faixasServico
                .filter(f => f.id_servico === id)
                .map(f => ({ minimo: f.qtde_de, maximo: f.qtde_ate, bonus: f.valor_bonus })))
            };
          });
        }
      }

      let modelosSelecionados = [];
      if (meta.id_tipo_conteudo == 3) {
        const source = meta.id_tipo_calculo != 2 ? info.modelos : info.faixasModelo;
        const seen = new Map();
        source.forEach(m => { if (!seen.has(m.id_produto)) seen.set(m.id_produto, m.descricao_modelo); });
        modelosSelecionados = [...seen.entries()].map(([id, desc]) => ({ id_produto: id, descricao_modelo: desc }));
      }
      if (meta.id_tipo_conteudo == 4) {
        const source = meta.id_tipo_calculo != 2 ? info.pecas : info.faixasPeca;
        const seen = new Map();
        source.forEach(p => { if (!seen.has(p.id_peca)) seen.set(p.id_peca, p.peca_acessorio); });
        modelosSelecionados = [...seen.entries()].map(([id, desc]) => ({ id_peca: id, peca_acessorio: desc }));
      }
      if (meta.id_tipo_conteudo == 5) {
        const source = meta.id_tipo_calculo != 2 ? info.servicos : info.faixasServico;
        const seen = new Map();
        source.forEach(s => { if (!seen.has(s.id_servico)) seen.set(s.id_servico, s.servico); });
        modelosSelecionados = [...seen.entries()].map(([id, desc]) => ({ id_servico: id, servico: desc }));
      }

      // Camada do participante (Task 4/20): usa_meta_colaborador/id_origem_meta/
      // etc vem repetidos em toda linha da meta (mesmo padrao de
      // id_tipo_conteudo etc acima) — lidos direto de `meta`, a primeira
      // linha do grupo (ver ListaCardMetas.todasMetas, que dedupe por
      // id_campanha_meta pegando a primeira linha de metasRegistradas).
      // mesesReferencia e metasCalculadas vem prontos da API, irmaos de
      // `data` na resposta (periodos_media e metas_colaborador, ambos
      // chaveados por id_campanha_meta, ver SectionPublicoMeta) — por isso
      // so sao lidos quando a camada esta realmente ligada, senao caem no
      // default vazio de iniciarNovaMeta (meta antiga, sem nenhum destes
      // campos).
      // Tipo de meta (Individual x Coletiva) nao e persistido — e inferido do
      // formato das linhas gravadas. Sem isto o wizard reabria SEMPRE em
      // "Coletiva", e o Salvar seguinte replicava o valor da primeira linha
      // para todos os participantes, apagando as metas individuais.
      // Ver metaIndividualLeituraUtils.
      const linhasDaMeta = (this.metasRegistradas || []).filter(
        r => r.id_campanha_meta == meta.id_campanha_meta
      );
      const isIndividual = detectarMetaIndividual(linhasDaMeta);
      const metasIndividuaisItens = isIndividual && meta.id_tipo_conteudo != 1
        ? montarMetasIndividuaisItens(linhasDaMeta)
        : {};
      const metasIndividuais = isIndividual && meta.id_tipo_conteudo == 1
        ? montarMetasIndividuaisIndicador(linhasDaMeta)
        : {};

      const usaMetaColaborador = meta.usa_meta_colaborador === "S";
      const metasCalculadas = usaMetaColaborador
        ? montarMetasCalculadas(this.metasColaborador && this.metasColaborador[meta.id_campanha_meta])
        : {};
      const mesesReferencia = usaMetaColaborador
        ? (this.periodosMedia && this.periodosMedia[meta.id_campanha_meta]) || []
        : [];
      // Mesmo padrao de mesesReferencia: so existe quando a camada esta
      // ligada e a origem e Media historica com crescimento Progressivo —
      // vazio nos demais casos (Fixo nao tem faixas para ler).
      const faixasCrescimento = usaMetaColaborador
        ? (this.faixasMedia && this.faixasMedia[meta.id_campanha_meta]) || []
        : [];

      this.editandoMeta = true;
      this.novaMetaForm = {
        tipoRealizado: meta.id_tipo_realizado ? Number(meta.id_tipo_realizado) : null,
        tipoConteudo: meta.id_tipo_conteudo ? Number(meta.id_tipo_conteudo) : null,
        origemConteudo: meta.id_origem_conteudo ? Number(meta.id_origem_conteudo) : 1,
        usaMetaColaborador,
        origemMeta: meta.id_origem_meta ? Number(meta.id_origem_meta) : 1,
        origemBonusColaborador: meta.id_origem_bonus ? Number(meta.id_origem_bonus) : 1,
        mesesReferencia,
        percentualCrescimento: meta.media_percentual_crescimento != null ? Number(meta.media_percentual_crescimento) : 15,
        valorMinimoMeta: meta.media_valor_minimo != null ? Number(meta.media_valor_minimo) : 10,
        tipoCrescimentoMedia: meta.media_tipo_crescimento ? Number(meta.media_tipo_crescimento) : 1,
        // De/ate/crescimento (nomes do modal) <- faixa_de/faixa_ate/percentual_crescimento
        // (nomes do banco e do payload) — faixa_ate nulo (ultima faixa, sem
        // teto) vira "" para o campo desabilitado do modal exibir em branco.
        faixasCrescimento: faixasCrescimento.map(f => ({
          de: f.faixa_de,
          ate: f.faixa_ate == null ? "" : f.faixa_ate,
          crescimento: f.percentual_crescimento
        })),
        metasCalculadas,
        valorBonusColaborador: meta.valor_bonus_colaborador != null ? Number(meta.valor_bonus_colaborador) : null,
        comissaoReferencia: meta.referencia_bonus_colaborador || "P2",
        comissaoPercentual: meta.percentual_bonus_colaborador != null ? Number(meta.percentual_bonus_colaborador) : 50,
        // null = comissao ainda nao buscada nesta sessao de edicao. A busca
        // acontece ao entrar na etapa de calculo, como no cadastro novo.
        comissaoParticipantes: null,
        tipoCalculo: meta.id_tipo_calculo ? Number(meta.id_tipo_calculo) : null,
        tipoPagamento: meta.id_tipo_pagamento ? Number(meta.id_tipo_pagamento) : null,
        valorBonus: meta.valor_bonus || null,
        colaboradoresSelecionados,
        empresasRealizadoSelecionadas: [],
        equipesSelecionadas: [],
        indicadoresSelecionados: [],
        chassisSelecionados: meta.id_tipo_conteudo == 2 ? info.chassi : [],
        modelosSelecionados,
        metasIndicadores,
        metasModelos,
        tipoMeta: isIndividual ? "individual" : "coletiva",
        metasIndividuais,
        metasIndividuaisItens
      };

      if (meta.id_tipo_conteudo == 1) {
        try {
          const response = await http.get("/sistemas/indicadores", {
            params: { ativo: "S", ativa_campanha: "S", per_page: -1 }
          });
          const all = response.data.data || [];
          const sourceIds = meta.id_tipo_calculo == 2
            ? [...new Set(info.faixasIndicador.map(f => String(f.id_indicador)))]
            : info.indicadores.map(i => String(i.id_indicador));
          const selectedIds = new Set(sourceIds);
          this.novaMetaForm.indicadoresSelecionados = all.filter(i => selectedIds.has(String(i.id_indicador)));
        } catch (e) {
          this.$notify({ type: "error", text: getApiError(e, "Erro ao carregar indicadores") });
        }
      }

      if (meta.id_tipo_realizado == 2) {
        await this.carregarEquipes();
        const colEquipeIds = new Set(this.colaboradoresEquipesRaw.map(r => String(r.id_equipe)).filter(Boolean));
        const realizadoEquipeIds = (info.equipes || []).map(e => String(e.id_equipe));
        const isEquipeDeParticipante = realizadoEquipeIds.length > 0 &&
          realizadoEquipeIds.every(id => colEquipeIds.has(id));
        if (isEquipeDeParticipante) {
          this.novaMetaForm.equipesSelecionadas = [{ id_equipe: 1, nome_equipe: 'Equipe de cada participante' }];
        } else {
          this.novaMetaForm.equipesSelecionadas = this.equipesLocais.filter(e =>
            info.equipes.some(ie => ie.id_equipe == e.id_equipe)
          );
        }
      }

      if (meta.id_tipo_realizado == 3) {
        await this.carregarEmpresasParticipantes();
        const colEmpresaIds = new Set(colaboradoresSelecionados.map(c => String(c.id_empresa)).filter(Boolean));
        const realizadoEmpresaIds = (info.empresas || []).map(e => String(e.id_empresa));
        const isEmpresaDeParticipante = realizadoEmpresaIds.length > 0 &&
          realizadoEmpresaIds.every(id => colEmpresaIds.has(id));
        if (isEmpresaDeParticipante) {
          this.novaMetaForm.empresasRealizadoSelecionadas = [{ id_empresa: 1, apelido: 'Empresa de cada participante' }];
        } else {
          this.novaMetaForm.empresasRealizadoSelecionadas = this.getEmpresasParticipantes.filter(e =>
            info.empresas.some(ie => ie.id_empresa == e.id_empresa)
          );
        }
      }

      this.subEtapa = 1;
      this.$nextTick(() => { this.editandoMeta = false; });
    },

    async salvarNovaMeta() {
      this.loadingSalvar = true;
      try {
        const form = this.novaMetaForm;
        const idCampanha = this.$route.params.idCampanha;

        let semanas = [];
        if (this.campanha.id_tipo_dado === "C") {
          const { data } = await campanhas(idCampanha).campanhaTipoFechamentoSemanal().show({});
          semanas = (data.data || []).map(s => s.id_tipo_fechamento);
        }

        const isIndividual = form.tipoMeta === "individual";
        const metasItens = form.metasIndividuaisItens || {};
        const metasInd = form.metasIndividuais || {};
        const colabs = form.colaboradoresSelecionados;

        const buildFaixas = (faixas) =>
          (faixas || []).map(f => ({ qtde_de: parseFloat(f.minimo), qtde_ate: parseFloat(f.maximo), valor_bonus: parseFloat(f.bonus) }));

        // Retorna os dados do item para um colaborador (individual ou coletivo)
        const getItemData = (id_colaborador, id_item) =>
          isIndividual ? (metasItens[id_colaborador] || {})[id_item] || {} : form.metasModelos[id_item] || {};

        // Cada array usa flatMap(itens × colaboradores) com id_colaborador e id_empresa dentro de cada entrada
        //
        // m.id_produto e a chave interna do item (veiculo OU cota, o catalogo
        // de cotas devolve o id nessa mesma propriedade de proposito, ver
        // ModalCadastroMeta topo do arquivo/CLAUDE.md). No payload, porem, os
        // dois catalogos tem colunas distintas no banco (id_produto tem FK pra
        // PRODUTO_MODELO, id_modelo_ihs nao existe la) — nunca os dois juntos,
        // senao ORA-02291 pra cota de consorcio (ver database/ddl/fase-1b-ddl-modelo-consorcio.sql).
        const buildModelos = () => form.modelosSelecionados.flatMap(m =>
          colabs.map(c => {
            const item = getItemData(c.id_colaborador, m.id_produto);
            const catalogoModelo = Number(form.origemConteudo) === 2
              ? { id_modelo_ihs: m.id_produto }
              : { id_produto: m.id_produto };
            return {
              id_colaborador: c.id_colaborador,
              id_empresa: c.id_empresa,
              ...catalogoModelo,
              valor_meta: form.tipoCalculo !== 2 ? parseFloat(item.metaValor) || null : null,
              valor_bonus: form.tipoCalculo !== 2 ? parseFloat(item.valorBonus) || null : null,
              faixas: form.tipoCalculo === 2 ? buildFaixas(item.faixas) : []
            };
          })
        );

        const buildPecas = () => form.modelosSelecionados.flatMap(m =>
          colabs.map(c => {
            const item = getItemData(c.id_colaborador, m.id_peca);
            return {
              id_colaborador: c.id_colaborador,
              id_empresa: c.id_empresa,
              id_peca: m.id_peca,
              valor_meta: form.tipoCalculo !== 2 ? parseFloat(item.metaValor) || null : null,
              valor_bonus: form.tipoCalculo !== 2 ? parseFloat(item.valorBonus) || null : null,
              faixas: form.tipoCalculo === 2 ? buildFaixas(item.faixas) : []
            };
          })
        );

        const buildServicos = () => form.modelosSelecionados.flatMap(m =>
          colabs.map(c => {
            const item = getItemData(c.id_colaborador, m.id_servico);
            return {
              id_colaborador: c.id_colaborador,
              id_empresa: c.id_empresa,
              id_servico: m.id_servico,
              valor_meta: form.tipoCalculo !== 2 ? parseFloat(item.metaValor) || null : null,
              valor_bonus: form.tipoCalculo !== 2 ? parseFloat(item.valorBonus) || null : null,
              faixas: form.tipoCalculo === 2 ? buildFaixas(item.faixas) : []
            };
          })
        );

        const buildChassi = () => form.chassisSelecionados.flatMap(ch =>
          colabs.map(c => ({
            id_colaborador: c.id_colaborador,
            id_empresa: c.id_empresa,
            chassi_completo: ch.chassi_completo,
            chassi_resumido: ch.chassi_resumido,
            valor_bonus: isIndividual
              ? parseFloat((metasItens[c.id_colaborador] || {})[ch.chassi_completo]?.valorBonus) || null
              : parseFloat(ch.valor_bonus) || null
          }))
        );

        const buildIndicadores = () => ({
          meta_indicador: form.indicadoresSelecionados.flatMap(ind =>
            colabs.map(c => {
              if (isIndividual) {
                const dados = metasInd[c.id_colaborador] || {};
                return {
                  id_colaborador: c.id_colaborador,
                  id_empresa: c.id_empresa,
                  id_indicador: ind.id_indicador,
                  valor_meta: form.tipoCalculo !== 2 ? parseFloat(dados.metas?.[ind.id_indicador]) || null : null,
                  valor_bonus: form.tipoCalculo !== 2 ? parseFloat(dados.valorBonus) || null : null,
                  faixas: form.tipoCalculo === 2 ? buildFaixas(dados.metas?.[ind.id_indicador]?.faixas) : []
                };
              }
              return {
                id_colaborador: c.id_colaborador,
                id_empresa: c.id_empresa,
                id_indicador: ind.id_indicador,
                valor_meta: form.tipoCalculo !== 2 ? parseFloat(form.metasIndicadores[ind.id_indicador]?.metaValor) || null : null,
                valor_bonus: form.tipoCalculo !== 2 ? parseFloat(form.valorBonus) || null : null,
                faixas: form.tipoCalculo === 2 ? buildFaixas(form.metasIndicadores[ind.id_indicador]?.faixas) : []
              };
            })
          )
        });

        const payload = {
          id_campanha: idCampanha,
          id_tipo_realizado: form.tipoRealizado,
          id_tipo_conteudo: form.tipoConteudo,
          id_tipo_calculo: form.tipoCalculo,
          id_tipo_pagamento: form.tipoPagamento,
          semanas,
          equipes: form.tipoRealizado === 2 ? this.expandirEquipesPayload(form) : [],
          empresas: form.tipoRealizado === 3 ? this.expandirEmpresasPayload(form) : [],
          indicadores: form.tipoConteudo === 1 ? buildIndicadores() : [],
          chassi: form.tipoConteudo === 2 ? buildChassi() : [],
          modelos: form.tipoConteudo === 3 ? buildModelos() : [],
          pecas: form.tipoConteudo === 4 ? buildPecas() : [],
          servicos: form.tipoConteudo === 5 ? buildServicos() : [],
          // Camada do participante e exclusiva do objetivo Modelo (tipoConteudo
          // 3). Os demais objetivos (Indicador/Chassi/Peca/Servico) voltam a
          // enviar exatamente o payload de antes desta feature — nao se sabe
          // se a API real rejeita campo desconhecido, e quebrar o cadastro
          // inteiro por causa de uma feature que so vale para Modelo custaria
          // caro demais.
          ...(form.tipoConteudo === 3 ? montarExtrasMeta(form) : {})
        };

        if (this.metaEmEdicao) {
          await campanhas().metasCampanha(this.metaEmEdicao.id_campanha_meta).update(payload);
          this.$notify({ type: "success", text: "Meta atualizada com sucesso!" });
        } else {
          await campanhas().metasCampanha().store(payload);
          this.$notify({ type: "success", text: "Meta cadastrada com sucesso!" });
        }

        this.$emit("meta-salva");
        this.fecharDialogNovaMeta();
      } catch (e) {
        this.$notify({ type: "error", text: getApiError(e, "Erro ao salvar a meta. Verifique os dados e tente novamente.") });
      } finally {
        this.loadingSalvar = false;
      }
    },

    async carregarColaboradoresParticipantes() {
      this.loadingColaboradores = true;
      const resultado = [];
      try {
        const idBand = [...new Set(this.getEmpresasParticipantes.map(e => e.id_band))].join(",");
        const filter = {
          per_page: -1,
          ativo: "S",
          ativa_campanha: "S",
          id_band: idBand,
          id_empresa: this.getEmpresasParticipantes.map(e => e.id_empresa)
        };
        const response = await colaboradorService.getColaboradoresEmpresa(filter);
        if ((response.data.data || []).length === 0) {
          this.$notify({ type: "error", text: "Nenhum colaborador encontrado nas empresas participantes" });
        }
        (response.data.data || []).forEach(colab => {
          resultado.push({ ...colab, _funcao: colab.funcao || "Função", _id_funcao: colab.id_funcao });
        });
        this.colaboradoresParticipantes = resultado;
      } catch (e) {
        this.$notify({ type: "error", text: getApiError(e, "Erro ao buscar colaboradores") });
      } finally {
        this.loadingColaboradores = false;
      }
    },

    async carregarEquipes() {
      this.loadingEquipes = true;
      this.equipesLocais = [];
      try {
        const idColaboradores = this.novaMetaForm.colaboradoresSelecionados.map(c => c.id_colaborador);
        const idEmpresas = this.getEmpresasParticipantes.map(e => e.id_empresa);
        const { data } = await colaboradorService.getColaboradoresEquipe({
          per_page: -1,
          ativo: "S",
          id_colaborador: idColaboradores,
          id_empresa: idEmpresas
        });
        this.colaboradoresEquipesRaw = data.data || [];
        const vistas = new Set();
        this.equipesLocais = this.colaboradoresEquipesRaw.filter(item => {
          if (!item.id_equipe || vistas.has(item.id_equipe)) return false;
          vistas.add(item.id_equipe);
          return true;
        });
      } catch (e) {
        this.$notify({ type: "error", text: getApiError(e, "Erro ao buscar equipes") });
      } finally {
        this.loadingEquipes = false;
      }
    },

    async carregarEmpresasParticipantes() {
      this.loadingEmpresas = true;
      try {
        await this.$store.dispatch("campanha/actionEmpresasParticipantes", this.$route.params.idCampanha);
      } catch (e) {
        this.$notify({ type: "error", text: getApiError(e, "Erro ao buscar empresas") });
      } finally {
        this.loadingEmpresas = false;
      }
    },

    expandirEquipesPayload(form) {
      const hasFixo = form.equipesSelecionadas.some(e => e.id_equipe == 1);
      const resultado = [];

      if (!hasFixo) {
        // Equipe(s) específica(s): todos os colaboradores vinculados a cada equipe selecionada
        for (const col of form.colaboradoresSelecionados) {
          for (const equipe of form.equipesSelecionadas) {
            resultado.push({ id_colaborador: col.id_colaborador, id_equipe: equipe.id_equipe });
          }
        }
        return resultado;
      }

      // "Equipe de cada participante": cada colaborador vinculado à sua própria equipe
      for (const col of form.colaboradoresSelecionados) {
        const relacao = this.colaboradoresEquipesRaw.find(
          r => r.id_colaborador == col.id_colaborador && r.id_equipe
        );
        if (relacao) {
          resultado.push({ id_colaborador: col.id_colaborador, id_equipe: relacao.id_equipe });
        }
      }
      return resultado;
    },

    expandirEmpresasPayload(form) {
      const hasFixo = form.empresasRealizadoSelecionadas.some(e => e.id_empresa == 1);
      const resultado = [];

      if (!hasFixo) {
        // Empresa(s) específica(s): todos os colaboradores vinculados a cada empresa selecionada
        for (const col of form.colaboradoresSelecionados) {
          for (const empresa of form.empresasRealizadoSelecionadas) {
            resultado.push({ id_colaborador: col.id_colaborador, id_empresa: empresa.id_empresa });
          }
        }
        return resultado;
      }

      // "Empresa de cada participante": cada colaborador vinculado à sua própria empresa
      for (const col of form.colaboradoresSelecionados) {
        if (col.id_empresa) {
          resultado.push({ id_colaborador: col.id_colaborador, id_empresa: col.id_empresa });
        }
      }
      return resultado;
    },

    getFaixasIndicador(idIndicador) {
      const entry = this.novaMetaForm.metasIndicadores[idIndicador];
      return entry && entry.faixas ? entry.faixas : [];
    },

    getFaixasModelo(idKey) {
      const entry = this.novaMetaForm.metasModelos[idKey];
      return entry && entry.faixas ? entry.faixas : [];
    },

    getMetaModeloValor(idKey, campo) {
      const entry = this.novaMetaForm.metasModelos[idKey];
      return entry ? entry[campo] : "";
    },

    getFaixaOrdemErro(idIndicador, idx) {
      if (idx === 0) return "";
      const faixas = this.getFaixasIndicador(idIndicador);
      const atual = faixas[idx];
      const anterior = faixas[idx - 1];
      if (!atual || !anterior || atual.minimo === "" || !anterior.maximo) return "";
      return parseFloat(atual.minimo) <= parseFloat(anterior.maximo)
        ? `Mínimo deve ser > ${anterior.maximo}`
        : "";
    },

    getFaixaOrdemErroModelo(idKey, idx) {
      if (idx === 0) return "";
      const faixas = this.getFaixasModelo(idKey);
      const atual = faixas[idx];
      const anterior = faixas[idx - 1];
      if (!atual || !anterior || atual.minimo === "" || !anterior.maximo) return "";
      return parseFloat(atual.minimo) <= parseFloat(anterior.maximo)
        ? `Mínimo deve ser > ${anterior.maximo}`
        : "";
    },

    formatarMoedaLocal(value) {
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(parseFloat(value) || 0);
    }
  }
};
</script>

<style scoped>
.draggable-area-ind {
  min-height: 150px;
  max-height: 250px;
  padding: 8px;
  overflow: auto;
}

.draggable-area-ind.include-ind {
  border: 2px dashed hsla(128, 100%, 34%, 0.39);
}

.draggable-area-ind.include-ind::-webkit-scrollbar-track { background-color: #adf3af; }
.draggable-area-ind.include-ind::-webkit-scrollbar { width: 6px; }
.draggable-area-ind.include-ind::-webkit-scrollbar-thumb { background: #2a772c; }

.draggable-area-ind.exclude-ind {
  border: 2px dashed hsla(347, 100%, 34%, 0.39);
}

.draggable-area-ind.exclude-ind::-webkit-scrollbar-track { background-color: #e7b8b8; }
.draggable-area-ind.exclude-ind::-webkit-scrollbar { width: 6px; }
.draggable-area-ind.exclude-ind::-webkit-scrollbar-thumb { background: #9b3232; }
</style>
